import { connect } from 'react-redux'
import AdditionalInfo from './view'

export default connect(null, {})(AdditionalInfo)
